import { Controller } from '@hotwired/stimulus';
import React from 'react';
import ReactDOM from 'react-dom/client';

// Lazy load components, so components are not loaded
// until called by this controller.
const EditorApp = React.lazy(() => import('~/apps/EditorApp'));
const ExampleApp = React.lazy(() => import('~/apps/ExampleApp'));
const PrintApp = React.lazy(() => import('~/apps/PrintApp'));
const SharedBooksApp = React.lazy(() => import('~/apps/SharedBooksApp'));

const COMPONENTS = {
  EditorApp,
  ExampleApp,
  PrintApp,
  SharedBooksApp,
};

export default class RenderReactController extends Controller {
  // Values associated with this controller.
  static values = {
    // Name of the React component
    component: String,
    // JSON formatted properties passed to the React component.
    props: String,
  };

  connect() {
    const componentName = this.componentValue;
    let props = {};
    if (this.propsValue) {
      props = JSON.parse(this.propsValue);
    }

    const Component = COMPONENTS[componentName];
    if (!Component) {
      console.error(`React component ${componentName} doesn't exist.`);
      return null;
    }

    this.root = ReactDOM.createRoot(this.element);
    this.root.render(
      <React.Suspense
        fallback={
          <div className="fixed inset-0 flex flex-row justify-center items-center">
            <div className="loading loading-spinner loading-lg" />
          </div>
        }
      >
        <Component {...props} />
      </React.Suspense>
    );
  }

  disconnect() {
    // Make sure to unmount when the component is disconnected to avoid warning:
    //    Warning: You are calling ReactDOMClient.createRoot() on a container
    //    that has already been passed to createRoot() before. Instead, call
    //    root.render() on the existing root instead if you want to update it.
    this.root?.unmount();
  }
}
